import { SupabaseService } from "../../../server/supabase/base-supabase-service";

/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type { Database } from "../../../__definitions__/database-definitions";
import type { UUID } from "../../../utils/uuid";

export type Folder = NonNullable<Database["public"]["Tables"]["folder"]["Row"]>;

export class SupabaseFolderService extends SupabaseService<"folder"> {
  table = "folder" as const;

  async deleteFolderAndContents(folderId: UUID) {
    return this.log_errors(this.client.rpc("delete_folder_and_contents", { folder_id: folderId }));
  }
}
